import React from 'react';

const ChineseKnot = ({ size = 100 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className="inline-block"
    >
      <g transform="translate(50, 50)">
        {/* Outer diamond */}
        <rect
          x="-25"
          y="-25"
          width="50"
          height="50"
          fill="none"
          stroke="#de2910"
          strokeWidth="3"
          transform="rotate(45)"
        />
        {/* Inner diamond */}
        <rect
          x="-15"
          y="-15"
          width="30"
          height="30"
          fill="none"
          stroke="#ffde00"
          strokeWidth="2"
          transform="rotate(45)"
        />
        {/* Center circle */}
        <circle
          cx="0"
          cy="0"
          r="8"
          fill="#de2910"
        />
        {/* Decorative loops */}
        <path
          d="M -20,-20 Q -30,-10 -20,0 Q -10,10 0,0 Q 10,-10 0,-20 Q -10,-30 -20,-20"
          fill="none"
          stroke="#de2910"
          strokeWidth="2"
        />
        <path
          d="M 20,-20 Q 30,-10 20,0 Q 10,10 0,0 Q -10,-10 0,-20 Q 10,-30 20,-20"
          fill="none"
          stroke="#de2910"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default ChineseKnot;


